import { css } from "styled-components";
import { Border } from "../../../../../../styles/common/mixins/logical.styled.js";
const veciTabsStyles = {
    TabsStyledVertical: ()=>css`
		box-shadow: none;
		${({ theme  })=>Border({
                all: `1px solid ${theme.border.color.light}`
            })};
	`,
    TabsButton: ()=>css`
		--active-border-bottom-color: ${({ theme  })=>theme.colors.primary.base};
		--vertical-border-bottom-color: ${({ theme  })=>theme.border.color.light};
		--active-color: ${({ theme  })=>theme.colors.primary.base};

		color: ${({ theme  })=>theme.colors.grays.darker};
	`,
    TabsVerticalWrapper: ()=>css`
		border-right-color: ${({ theme  })=>theme.border.color.light};
	`,
    TabsVerticalIcon: ()=>css`
		color: ${({ theme  })=>theme.colors.secondary.base};
	`
};
export default veciTabsStyles;

//# sourceMappingURL=veci.js.map